import { Box } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { PaginationStoreType } from 'stores/NewPaginationStore'
import { getStyles } from '../../../../utils/utils/commonUtils'
import { RequestsTabType } from '../../../../views/Service/components/AdminTables/stores/AdminServiceTablesStore'
import requestsManagementStyles from '../../styles/requestsManagementStyles'
import RequestsNewTable from './NewRequestsTable'
import RequestsTableFilters from './RequestsTableFilters'
import { RequestsTableFilterStoreType } from './stores/RequestsTableFilterStore'
import { RequestTableParamsType } from './types/new-requests-table.types'

interface DealerTabbedTableViewProps {
  tab?: RequestsTabType
  paginationStore: PaginationStoreType<RequestTableParamsType>
  filtersStore: RequestsTableFilterStoreType
  checkboxStore: any
}

const DealerTabbedTableView: FC<DealerTabbedTableViewProps> = ({
  tab,
  paginationStore,
  filtersStore,
  checkboxStore,
}) => {
  const classes = getStyles(requestsManagementStyles)

  return (
    <>
      <Box>
        <RequestsTableFilters
          paginationStore={paginationStore}
          filtersStore={filtersStore}
          checkboxStore={checkboxStore}
          tab={tab}
        />
        <Box sx={classes.tableWrapper}>
          <RequestsNewTable
            paginationStore={paginationStore}
            checkboxStore={checkboxStore}
          />
        </Box>
      </Box>
    </>
  )
}

export default observer(DealerTabbedTableView)
